module.exports = __webpack_public_path__ + "img/screen-img-01.46b80767.webp";